import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

/**
 * Root application component.
 * Auth session is initialized via APP_INITIALIZER in main.ts.
 */
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [RouterOutlet],
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  title = "ErpCaAgentBMFPWeb";
}
